export default "__VITE_ASSET__6f5e470c__"